import { apiClient, Auth } from '@/shared/api'
import { action } from '@/shared/config'

export const deleteUserMe = action
  .metadata({
    actionName: 'deleteUserMeAction',
  })
  .action(async () => {
    await apiClient.delete({
      endpoint: '/user/me',
      auth: Auth.REQUIRED,
    })
  })
